export default __webpack_public_path__ + "static/media/Social Links.850004f7.svg";